import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from'../Component/Header';
import Footer from'../Component/Footer'; 
import LazyLoad from 'react-lazyload';
const About = () => {
    useEffect(() => {
        document.title = 'About -  Sacred Heart School, Ballia - U.P.';  
    }, []); 
    return (
        <>
        <Header/>
            <section className="page-header"> 
                    <div className="page-header__inner">
                    <h2>General Information </h2>
                        <ul className="thm-breadcrumb list-unstyled ml-0">
                            <li><Link to="/"> Home</Link></li>
                            <li>|</li>
                            <li>About</li>
                            <li>|</li>
                            <li> General Information </li>
                        </ul> 
                </div>
            </section>
            <section className="innerbody">
               <div className='container'>
                <div className='row'>
                    <div className='col-md-6'>
                      <LazyLoad>  <img src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SHSSB/public/Images/about-us.jpg" alt="Sacred Heart School, Ballia" className='img-fluid' /></LazyLoad>
                    </div>
                    <div className='col-md-6'>
                    <p>Sacred Heart School (Affiliated to CISCE) serves students from Ballia city and the nearby villages. It promises to provide quality education that enables students to be inspired learners and responsible global citizens. With the help and support of its dedicated faculty the school will ensure the overall development of its students. We at Sacred Heart School believe each individual has intrinsic value and every person needs nurturing to thrive. Our aim to serve the society strengthens us. We are committed to develop a community service ethic and practice in all students. The school focuses on the pursuit of knowledge and skill. In particular we desire to attain the highest academic standards.</p>
                    </div>
                </div>
               </div>
             </section>
            <Footer/>
        </>
    )
}

export default About